// FEAT-061: RAYGuard AI 검색창 노출 대상 회사 (본인 companyId 정확 일치만 허용).
// 하위 회사(clist)는 포함하지 않는다. BE 에서도 동일하게 재검증한다.
// RAY00001 RAY_HQ, RAY00010 Ray America, RAY00011 Ray Australia, RAY00015 Ray Japan,
// RAY00016 RAY TAIWAN, RAY00100 Ray China, RAY02123 Ray Vina, RAY90096 유럽서비스센터
export const AI_SEARCH_COMPANY_IDS = Object.freeze([
	'RAY00001',
	'RAY00010',
	'RAY00011',
	'RAY00015',
	'RAY00016',
	'RAY00100',
	'RAY02123',
	'RAY90096',
]);

// 허용 회사 밖이지만 PL 이 개별 승인한 사용자(adminid 정확 일치). BE rayguardAiUsers 와 동일 목록.
// 2026-10-21 유럽서비스센터 하위 회사 6명(김보광 요청): RAY00013 서유럽·CIS·중동, RAY90098 DACH, RAY10005 동유럽, RAY02078 프랑스
export const AI_SEARCH_USER_IDS = Object.freeze([
	'bkkim',
	'jjc7605@rayeurope.com',
	'rostand.longtchi',
	'j.lee@rayeurope.com',
	'CS_EE',
	'support@raymedical.fr',
]);

export const canUseAiSearch = (user) =>
	AI_SEARCH_COMPANY_IDS.includes(user?.companyId) || AI_SEARCH_USER_IDS.includes(user?.adminid);
